import services from 'api/services';
import { logError } from 'global/errors';

import {
  LOAD_SUPERADMIN_REQUEST,
  LOAD_SUPERADMIN_SUCCESS,
  LOAD_SUPERADMIN_FAILURE,
  CREATE_COMPANY_REQUEST,
  CREATE_COMPANY_SUCCESS,
  CREATE_COMPANY_FAILURE,
  UPDATE_COMPANY_FAILURE,
  UPDATE_COMPANY_REQUEST,
  UPDATE_COMPANY_SUCCESS,
  UPDATE_ADMIN_COMPANY_REQUEST,
  UPDATE_ADMIN_COMPANY_SUCCESS,
  UPDATE_ADMIN_COMPANY_FAILURE,
  UPDATE_CONFIG_EMAILS_REQUEST,
  UPDATE_CONFIG_EMAILS_SUCCESS,
  UPDATE_CONFIG_EMAILS_FAILURE,
  UPDATE_CONFIG_REQUEST,
  UPDATE_CONFIG_SUCCESS,
  UPDATE_CONFIG_FAILURE,
  UPDATE_PLAN_REQUEST,
  UPDATE_PLAN_SUCCESS,
  UPDATE_PLAN_FAILURE,
} from './constants';

const { CompanyService, AccountService, ConfigService } = services;

export const loadSuperAdmin = () => async (dispatch) => {
  try {
    dispatch({ type: LOAD_SUPERADMIN_REQUEST });
    const [config, companies] = await Promise.all([
      CompanyService.getSuperAdminConfig(),
      CompanyService.getSuperAdminCompanies(),
    ]);
    dispatch({ type: LOAD_SUPERADMIN_SUCCESS, data: { config, companies } });
  } catch (ex) {
    logError(ex);
    dispatch({ type: LOAD_SUPERADMIN_FAILURE, error: ex.message });
  }
};

export const createCompany = (body) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_COMPANY_REQUEST });
    const newCompany = await CompanyService.createCompany(body);
    dispatch({ type: CREATE_COMPANY_SUCCESS, data: newCompany });
  } catch (ex) {
    logError(ex);
    dispatch({ type: CREATE_COMPANY_FAILURE, error: ex.message });
  }
};

export const updateAdminCompany = (companyId) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_ADMIN_COMPANY_REQUEST });
    const updatedUser = await AccountService.updateAdminCompany(companyId);
    dispatch({ type: UPDATE_ADMIN_COMPANY_SUCCESS, data: updatedUser });
  } catch (ex) {
    logError(ex);
    dispatch({ type: UPDATE_ADMIN_COMPANY_FAILURE, error: ex.message });
  }
};

export const updateCompany = (id, body) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_COMPANY_REQUEST });
    const updatedCompany = await CompanyService.updateCompany(id, body);
    dispatch({ type: UPDATE_COMPANY_SUCCESS, data: updatedCompany });
  } catch (ex) {
    logError(ex);
    dispatch({ type: UPDATE_COMPANY_FAILURE, error: ex.message });
  }
};

export const updateEmails = (body) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_CONFIG_EMAILS_REQUEST });
    const areEmailsUpdated = await ConfigService.updateEmails(body);
    dispatch({ type: UPDATE_CONFIG_EMAILS_SUCCESS, data: areEmailsUpdated });
  } catch (ex) {
    logError(ex);
    dispatch({ type: UPDATE_CONFIG_EMAILS_FAILURE, error: ex.message });
  }
};

export const updateConfig = (id, body) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_CONFIG_REQUEST });
    const config = await ConfigService.updateConfig(id, body);
    dispatch({ type: UPDATE_CONFIG_SUCCESS, data: config });
  } catch (ex) {
    logError(ex);
    dispatch({ type: UPDATE_CONFIG_FAILURE, error: ex.message });
  }
};

export const updatePlan = (body) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_PLAN_REQUEST });
    const plan = await ConfigService.updatePlan(body);
    dispatch({ type: UPDATE_PLAN_SUCCESS, data: plan });
  } catch (ex) {
    logError(ex);
    dispatch({ type: UPDATE_PLAN_FAILURE, error: ex.message });
  }
};
